import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import {
  FaEdit,
  FaPlus,
  FaSave,
  FaSearch,
  FaTags,
  FaTimes,
  FaTrash,
  FaUsers,
} from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const STYLES = `
  .mdl-dbm-dialog.modal-dialog { max-width: 640px; margin: 0.75rem auto; }
  .mdl-dbm-dialog .modal-content {
    border-radius: 16px; overflow: hidden; border: none;
    box-shadow: 0 20px 44px rgba(1, 87, 155, 0.2);
  }
  .mdl-dbm-dialog .modal-header {
    border: none; padding: 14px 18px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
    color: #fff;
  }
  .mdl-dbm-dialog .modal-header .close {
    color: #fff; opacity: 0.9; text-shadow: none; font-size: 1.5rem;
  }
  .mdl-dbm-dialog .modal-body { padding: 0; background: #f4fafd; }
  .mdl-dbm-dialog .modal-footer {
    border-top: 1px solid #d7eef9; background: #fff; padding: 10px 16px;
  }
  .dbm-title { display: flex; align-items: center; gap: 10px; margin: 0; color: #fff; }
  .dbm-title__icon {
    width: 36px; height: 36px; border-radius: 10px;
    display: inline-flex; align-items: center; justify-content: center;
    background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.35);
  }
  .dbm-title__main { font-size: 15px; font-weight: 800; line-height: 1.2; }
  .dbm-title__hint { font-size: 11px; opacity: 0.9; margin-top: 2px; }
  .dbm-body { padding: 12px 14px; }
  .dbm-toolbar {
    display: flex; gap: 8px; flex-wrap: wrap; align-items: center; margin-bottom: 10px;
  }
  .dbm-search { position: relative; flex: 1 1 180px; min-width: 140px; }
  .dbm-search__icon {
    position: absolute; left: 10px; top: 50%; transform: translateY(-50%);
    color: #0288d1; font-size: 12px; pointer-events: none;
  }
  .dbm-search__input {
    width: 100%; height: 36px; border-radius: 9px; border: 1.5px solid #cfe8f7;
    padding: 0 10px 0 30px; font-size: 12.5px; background: #fff; outline: none;
  }
  .dbm-search__input:focus {
    border-color: #03a9f4; box-shadow: 0 0 0 3px rgba(3,169,244,0.14);
  }
  .dbm-btn {
    height: 36px; border-radius: 9px; border: none; padding: 0 12px;
    font-size: 12px; font-weight: 700; display: inline-flex; align-items: center;
    gap: 6px; cursor: pointer;
  }
  .dbm-btn--primary {
    background: linear-gradient(135deg, #03a9f4, #0288d1); color: #fff;
    box-shadow: 0 3px 10px rgba(2,136,209,0.28);
  }
  .dbm-btn--ghost {
    background: #fff; border: 1.5px solid #cfe8f7; color: #0277bd;
  }
  .dbm-btn--danger {
    background: #fff; border: 1.5px solid #fecaca; color: #b91c1c;
  }
  .dbm-btn:disabled { opacity: 0.55; cursor: not-allowed; }
  .dbm-form {
    background: #fff; border: 1.5px solid #b3e5fc; border-radius: 12px;
    padding: 10px 12px; margin-bottom: 10px;
  }
  .dbm-form__grid {
    display: grid; grid-template-columns: 1fr; gap: 8px;
  }
  .dbm-form__grid--party {
    grid-template-columns: 1.4fr 1fr 1fr;
  }
  @media (max-width: 640px) {
    .dbm-form__grid--party { grid-template-columns: 1fr; }
  }
  .dbm-field span {
    display: block; font-size: 10px; font-weight: 800; text-transform: uppercase;
    letter-spacing: 0.04em; color: #64748b; margin-bottom: 4px;
  }
  .dbm-field input {
    width: 100%; height: 36px; border-radius: 8px; border: 1.5px solid #cfe8f7;
    padding: 0 10px; font-size: 13px; outline: none;
  }
  .dbm-field input:focus {
    border-color: #03a9f4; box-shadow: 0 0 0 3px rgba(3,169,244,0.14);
  }
  .dbm-form__actions {
    display: flex; gap: 8px; justify-content: flex-end; margin-top: 8px;
  }
  .dbm-list {
    max-height: min(48vh, 380px); overflow-y: auto;
    display: flex; flex-direction: column; gap: 8px;
  }
  .dbm-row {
    display: flex; align-items: center; gap: 10px;
    background: #fff; border: 1.5px solid #e2e8f0; border-radius: 12px;
    padding: 10px 12px;
  }
  .dbm-row.is-editing { border-color: #03a9f4; background: #f0f9ff; }
  .dbm-row__meta { min-width: 0; flex: 1; }
  .dbm-row__name {
    margin: 0; font-size: 13.5px; font-weight: 750; color: #0f172a;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .dbm-row__sub {
    margin: 2px 0 0; font-size: 11px; color: #64748b;
  }
  .dbm-badge {
    font-size: 10px; font-weight: 800; padding: 2px 8px; border-radius: 999px;
    background: #e1f5fe; color: #0277bd; white-space: nowrap;
  }
  .dbm-badge--used { background: #fef3c7; color: #b45309; }
  .dbm-row__actions { display: inline-flex; gap: 6px; flex-shrink: 0; }
  .dbm-icon-btn {
    width: 30px; height: 30px; border-radius: 8px; border: 1.5px solid #cfe8f7;
    background: #fff; color: #0288d1; display: inline-flex; align-items: center;
    justify-content: center; cursor: pointer; font-size: 12px;
  }
  .dbm-icon-btn--danger { border-color: #fecaca; color: #dc2626; }
  .dbm-icon-btn:disabled { opacity: 0.45; cursor: not-allowed; }
  .dbm-empty {
    text-align: center; padding: 28px 12px; color: #64748b;
    background: #fff; border-radius: 12px; border: 1.5px dashed #cfe8f7;
  }
`;

//Created By Cursor
const MdlManageDaybookMaster = ({
  isOpen,
  onClose,
  masterType = "category", // category | party
}) => {
  const isParty = masterType === "party";
  const title = isParty ? "Manage Party" : "Manage Category";
  const hint = isParty
    ? "Add, edit, or delete parties. Delete only when unused."
    : "Add, edit, or delete categories. Delete only when unused.";
  const idKey = isParty ? "party_id" : "category_id";
  const nameKey = isParty ? "party_name" : "category_name";
  const manageApi = isParty
    ? "manageDaybookParty.php"
    : "manageDaybookCategory.php";
  const deleteApi = isParty
    ? "deleteDaybookParty.php"
    : "deleteDaybookCategory.php";

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");

  //Created By Cursor
  const loadList = useCallback(async () => {
    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) return;
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE()}${manageApi}`, {
        params: { school_code: schoolCode, action: "list", _ts: Date.now() },
        headers: { "Cache-Control": "no-cache" },
      });
      if (response.data?.api_status === "OK") {
        setRows(Array.isArray(response.data.data) ? response.data.data : []);
      } else {
        setRows([]);
        myToast.notify_warning(response.data?.api_remark || "Could not load list.");
      }
    } catch (e) {
      console.error(e);
      setRows([]);
      myToast.notify_warning("Network error loading list.");
    } finally {
      setLoading(false);
    }
  }, [manageApi]);

  useEffect(() => {
    if (!isOpen) return;
    setSearch("");
    setShowForm(false);
    setEditId("");
    setName("");
    setAddress("");
    setPhone("");
    loadList();
  }, [isOpen, loadList]);

  const visible = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((r) => {
      const hay = [r[nameKey], r.address, r.phone, r[idKey]]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return hay.includes(q);
    });
  }, [rows, search, nameKey, idKey]);

  //Created By Cursor
  const resetForm = () => {
    setShowForm(false);
    setEditId("");
    setName("");
    setAddress("");
    setPhone("");
  };

  //Created By Cursor
  const startAdd = () => {
    setEditId("");
    setName("");
    setAddress("");
    setPhone("");
    setShowForm(true);
  };

  //Created By Cursor
  const startEdit = (row) => {
    setEditId(row[idKey] || "");
    setName(row[nameKey] || "");
    setAddress(row.address || "");
    setPhone(row.phone || "");
    setShowForm(true);
  };

  //Created By Cursor
  const handleSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      myToast.notify_warning(
        isParty ? "Please enter party name." : "Please enter category name."
      );
      return;
    }
    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) return;
    try {
      setSaving(true);
      const params = {
        school_code: schoolCode,
        action: editId ? "update" : "add",
        [nameKey]: trimmed,
      };
      if (editId) params[idKey] = editId;
      if (isParty) {
        params.address = address.trim();
        params.phone = phone.trim();
      }
      const response = await axios.get(`${API_BASE()}${manageApi}`, { params });
      if (response.data?.api_status === "OK") {
        myToast.notify_success(
          response.data?.api_remark || (editId ? "Updated" : "Added")
        );
        resetForm();
        await loadList();
      } else {
        myToast.notify_warning(response.data?.api_remark || "Save failed.");
      }
    } catch (e) {
      console.error(e);
      myToast.notify_warning("Network error while saving.");
    } finally {
      setSaving(false);
    }
  };

  //Created By Cursor
  const handleDelete = async (row) => {
    const usage = Number(row.usage_count) || 0;
    if (usage > 0) {
      myToast.notify_warning(
        `Cannot delete: ${usage} expense record(s) use this ${
          isParty ? "party" : "category"
        }.`
      );
      return;
    }
    const label = row[nameKey] || "this item";
    if (
      !window.confirm(
        `Delete "${label}"? This can only be done when no expenses use it.`
      )
    ) {
      return;
    }
    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) return;
    try {
      setSaving(true);
      const response = await axios.get(`${API_BASE()}${deleteApi}`, {
        params: {
          school_code: schoolCode,
          [idKey]: row[idKey],
        },
      });
      if (response.data?.api_status === "OK") {
        myToast.notify_success(response.data?.api_remark || "Deleted");
        if (editId === row[idKey]) resetForm();
        await loadList();
      } else {
        myToast.notify_warning(response.data?.api_remark || "Delete failed.");
      }
    } catch (e) {
      console.error(e);
      myToast.notify_warning("Network error while deleting.");
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <style>{STYLES}</style>
      <Modal
        show={isOpen}
        onHide={onClose}
        animation={false}
        centered
        dialogClassName="mdl-dbm-dialog"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <div className="dbm-title">
            <span className="dbm-title__icon" aria-hidden>
              {isParty ? <FaUsers /> : <FaTags />}
            </span>
            <div>
              <div className="dbm-title__main">{title}</div>
              <div className="dbm-title__hint">{hint}</div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="dbm-body">
            <div className="dbm-toolbar">
              <div className="dbm-search">
                <FaSearch className="dbm-search__icon" aria-hidden />
                <input
                  type="search"
                  className="dbm-search__input"
                  placeholder={isParty ? "Search party…" : "Search category…"}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <button
                type="button"
                className="dbm-btn dbm-btn--primary"
                onClick={startAdd}
                disabled={saving}
              >
                <FaPlus aria-hidden /> Add new
              </button>
            </div>

            {showForm ? (
              <div className="dbm-form">
                <div
                  className={`dbm-form__grid${
                    isParty ? " dbm-form__grid--party" : ""
                  }`}
                >
                  <label className="dbm-field">
                    <span>{isParty ? "Party name *" : "Category name *"}</span>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder={isParty ? "Enter party name" : "Enter category"}
                      autoFocus
                    />
                  </label>
                  {isParty ? (
                    <>
                      <label className="dbm-field">
                        <span>Phone</span>
                        <input
                          type="text"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          placeholder="Optional"
                        />
                      </label>
                      <label className="dbm-field">
                        <span>Address</span>
                        <input
                          type="text"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          placeholder="Optional"
                        />
                      </label>
                    </>
                  ) : null}
                </div>
                <div className="dbm-form__actions">
                  <button
                    type="button"
                    className="dbm-btn dbm-btn--ghost"
                    onClick={resetForm}
                    disabled={saving}
                  >
                    <FaTimes aria-hidden /> Cancel
                  </button>
                  <button
                    type="button"
                    className="dbm-btn dbm-btn--primary"
                    onClick={handleSave}
                    disabled={saving}
                  >
                    <FaSave aria-hidden /> {editId ? "Update" : "Save"}
                  </button>
                </div>
              </div>
            ) : null}

            {loading ? (
              <div style={{ padding: 24 }}>
                <MyLoader />
              </div>
            ) : visible.length === 0 ? (
              <div className="dbm-empty">
                <p style={{ margin: 0, fontWeight: 700, color: "#334155" }}>
                  {rows.length === 0
                    ? isParty
                      ? "No parties yet"
                      : "No categories yet"
                    : "No matches"}
                </p>
                <p style={{ margin: "4px 0 0", fontSize: 12 }}>
                  {rows.length === 0
                    ? "Click Add new to create one."
                    : "Try a different search."}
                </p>
              </div>
            ) : (
              <div className="dbm-list">
                {visible.map((row) => {
                  const usage = Number(row.usage_count) || 0;
                  const canDelete = usage === 0;
                  const isEditing = editId && editId === row[idKey];
                  return (
                    <div
                      key={row[idKey]}
                      className={`dbm-row${isEditing ? " is-editing" : ""}`}
                    >
                      <div className="dbm-row__meta">
                        <p className="dbm-row__name">{row[nameKey] || "—"}</p>
                        {isParty && (row.phone || row.address) ? (
                          <p className="dbm-row__sub">
                            {[row.phone, row.address].filter(Boolean).join(" · ")}
                          </p>
                        ) : null}
                      </div>
                      <span
                        className={`dbm-badge${usage > 0 ? " dbm-badge--used" : ""}`}
                        title={
                          usage > 0
                            ? "Used in expenses — cannot delete"
                            : "Unused — can delete"
                        }
                      >
                        {usage} used
                      </span>
                      <div className="dbm-row__actions">
                        <button
                          type="button"
                          className="dbm-icon-btn"
                          title="Edit"
                          disabled={saving}
                          onClick={() => startEdit(row)}
                        >
                          <FaEdit aria-hidden />
                        </button>
                        <button
                          type="button"
                          className="dbm-icon-btn dbm-icon-btn--danger"
                          title={
                            canDelete
                              ? "Delete"
                              : "Cannot delete — linked expenses exist"
                          }
                          disabled={saving || !canDelete}
                          onClick={() => handleDelete(row)}
                        >
                          <FaTrash aria-hidden />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="dbm-btn dbm-btn--ghost" onClick={onClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MdlManageDaybookMaster;
